import { apiGetClient, apiPostClient, apiPutClient } from "../../../api/apiSvtAdmin";
import { toast } from 'react-toastify';
import i18n from "i18next";
const t = i18n.t.bind(i18n);


export const getAllRCMUsers = async () => {
    try {
        const response = await apiGetClient.get("rcmusers");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const createNewRCMUser = async (data) => {
    try {
        const response = await apiPostClient.post("rcmusers", data);
    toast.success(t("rcmUserCreatedSuccess", { emailId: data.emailId }), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response?.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const updateRCMUser = async (data, id) => {
    try {
        const response = await apiPutClient.put(`rcmusers/${id}`, data);
    toast.success(t("rcmUserUpdatedSuccess", { emailId: data.emailId }), { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};

export const getAllRoles = async () => {
    try {
        const response = await apiGetClient.get("foundation/roles");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const getAllRegionsWithCountry = async () => {
    try {
        const response = await apiGetClient.get("foundation/regions");
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const findRCMUsers = async (data) => {
    try {
        const response = await apiGetClient.get(`rcmusers?countryId=${data.countryId}&regionId=${data.regionId}`);
        return response.data;
    } catch (error) {
        toast.error(error.response.data.error, { position: "top-center" });
        return null;
    }
};

export const revokeRCMUser = async (data) => {
    try {
        let url = `rcmusers/revoke/${data.userId}?roleId=${data.roleId}&regionId=${data.regionId}`;
        if (data.countryId !== undefined) {
            url += `&countryId=${data.countryId}`
        }
        const response = await apiGetClient.put(url, data);
        // toast.success(response.data?.data, { position: "top-center" });
        return response.data;
    } catch (error) {
        let errorData = error.response.data;
        if (errorData?.errors) {
            Object.keys(errorData?.errors).forEach(field => {
                errorData?.errors[field].forEach(message => {
                    toast.error(message, { position: "top-center" });
                });
            });
        } else {
            toast.error(error.response.data?.error, { position: "top-center" });
        }
        return null;
    }
};
